import {
  phoneVerificationRequest,
  phoneVerificationSuccess,
  phoneVerificationError,
  otpVerificationRequest,
  otpVerificationSuccess,
  otpVerificationError,
  signupRequest,
  signupSuccess,
  signupError,
} from "./reducer";
import {
  phoneVerificationApi,
  checkPhoneOtpApi,
  submitSignupDetailApi,
} from "../../../services/authServcies";

// Phone Verification Thunk
export const verifyPhone = (data: {
  phoneno: string;
  countrycode: string;
  dialcode: string;
  languageid: number;
}) => async (dispatch: any) => {
  try {
    dispatch(phoneVerificationRequest());
    const response = await phoneVerificationApi(data);

    if (response.success) {
      dispatch(
        phoneVerificationSuccess(
          response.message || "OTP sent successfully to your phone"
        )
      );
      return { success: true, data: response.data };
    } else {
      dispatch(
        phoneVerificationError(
          response.message || "Failed to send OTP. Please try again."
        )
      );
      return { success: false, message: response.message };
    }
  } catch (error: any) {
    const errorMessage =
      error?.response?.data?.message ||
      "Phone verification failed. Please try again.";
    dispatch(phoneVerificationError(errorMessage));
    return { success: false, message: errorMessage };
  }
};

// OTP Verification Thunk
export const verifyOtp = (data: {
  phoneno: string;
  dialcode: string;
  countrycode: string;
  otp: string;
}) => async (dispatch: any) => {
  try {
    dispatch(otpVerificationRequest());
    const response = await checkPhoneOtpApi(data);

    if (response.success) {
      dispatch(
        otpVerificationSuccess(
          response.message || "OTP verified successfully"
        )
      );
      return { success: true, data: response.data };
    } else {
      dispatch(
        otpVerificationError(
          response.message || "Invalid OTP. Please try again."
        )
      );
      return { success: false, message: response.message };
    }
  } catch (error: any) {
    const errorMessage =
      error?.response?.data?.message ||
      "OTP verification failed. Please try again.";
    dispatch(otpVerificationError(errorMessage));
    return { success: false, message: errorMessage };
  }
};

// Signup Detail Submission Thunk
export const submitSignupDetails = (data: {
  phone_no: string;
  country_code: string;
  dial_code: string;
  language_id: number;
  first_name: string;
  middle_name?: string;
  last_name: string;
  dob: string;
  email_address: string;
  datausageconsent: boolean;
  iagreereceiveoffers: boolean;
  referal_code?: string;
}) => async (dispatch: any) => {
  try {
    dispatch(signupRequest());
    const response = await submitSignupDetailApi(data);

    if (response.success) {
      dispatch(
        signupSuccess(
          response.message || "Registration completed successfully"
        )
      );
      return { success: true, data: response.data };
    } else {
      dispatch(
        signupError(
          response.message || "Registration failed. Please try again."
        )
      );
      return { success: false, message: response.message };
    }
  } catch (error: any) {
    const errorMessage =
      error?.response?.data?.message ||
      "Registration failed. Please try again.";
    dispatch(signupError(errorMessage));
    return { success: false, message: errorMessage };
  }
};

